export default "__VITE_ASSET__Cc0STDPx__"